module.exports = __webpack_public_path__ + "media/images/pc/brands/eight/_main-visual-text-84f702a382ecf82a931445304e3027c5.svg";